/* @flow */

import usePlugin from 'plugin/base/hook/usePlugin';
import { socialSharingPlugin } from 'plugin/social-sharing/setting/socialSharingSettings';

export default function useSocialSharing(): boolean {
  return usePlugin(socialSharingPlugin);
}
